import type { DeviceIdentifier } from './PublicRequestReturnLabel.types'

export const countDeviceIdentifiers = (devices: DeviceIdentifier[]): number =>
  devices.reduce((total, device) => {
    if (!device.value.trim()) {
      return total
    }

    const commaValues = device.value
      .split(',')
      .map(v => v.trim())
      .filter(Boolean)

    return total + commaValues.length
  }, 0)

/** TODO: replace mock with real API call to validate hash */
export const validateHash = (hash: string): Promise<boolean> =>
  new Promise(resolve => {
    setTimeout(() => {
      resolve(hash === 'valid')
    }, 1500)
  })
